import { render, staticRenderFns } from "./transreceipt.vue?vue&type=template&id=3d519b03&"
import script from "./transreceipt.vue?vue&type=script&lang=js&"
export * from "./transreceipt.vue?vue&type=script&lang=js&"
import style0 from "./transreceipt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports